import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const MacrosMenuErrorState = () => {
  return /*#__PURE__*/_jsx(Flex, {
    "data-test-id": "macros-menu-error",
    blockSize: "300px",
    inlineSize: "100%",
    alignItems: "center",
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(View, {
      inlineSize: "200px",
      children: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.macros-menu.error-state"
        })
      })
    })
  });
};
MacrosMenuErrorState.displayName = 'MacrosMenuErrorState';